import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppEnvironmentConfig } from 'projects/config/model/environment.config.model';
import { SvcHttpClient } from 'projects/lib-shared-common/src/public-api';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SvcCopilotService extends SvcHttpClient {
  constructor(
    protected _appConfig: AppEnvironmentConfig,
    protected _httpClient: HttpClient
  ) {
    super(_appConfig.APIs.apiUrlCopilot, _httpClient);
  }

  public getUserAccessControl(): Observable<boolean> {
    return this.get('/UserAccessControl');
  }
}
